/*jshint esnext: true */
/*global jQuery, dis */

/* DIS/PLAY Script
 Author's name: Lars Munkholm
 Modified by:
 Client name: Danske Regioner
 Date of creation: 2.3.2016
 */


(function ($, dis) {
	"use strict";


	dis.ImageSlider = function () {
		dis.BaseModule.call(this);

		var selfScope = this;


		function init() {

			$('.slickslider-wrapper').slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 300,
				nextArrow: '<i class="arrownext"><svg role="img"><use xlink:href="/static/dist/icons.svg#arrow-right"></use></svg></i>',
				prevArrow: '<i class="arrowleft"><svg role="img"><use xlink:href="/static/dist/icons.svg#arrow-right"></use></svg></i>',
			});

		}

		selfScope.onReady(init);
	};

	dis.ImageSlider.prototype = new dis.BaseModule();
	dis.ImageSlider.constructor = dis.ImageSlider;


// This is where you define the global parameters you pass into your closure. You'll want to pass in any
// big stuff you'll need inside your script. Minor stuff can always be accessed through window.someVariable.
}(jQuery, dis));